// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"4e0707c8d1ed730e5f8a","777":"b63872d1f033353a0d09","939":"7f2709d8607d59a23acf"}[chunkId] + ".js";
};